import BestInProfession from '@/apps/BestInProfession'
import Layout from '@/apps/layout/components'
import React from 'react'

const BestInProfessionPage = (): React.ReactElement => {
  return (
    <Layout>
      <BestInProfession />
    </Layout>
  )
}

export default BestInProfessionPage
